import { render, staticRenderFns } from "./candidateInfoCard.vue?vue&type=template&id=6e2596b7&scoped=true"
import script from "./candidateInfoCard.vue?vue&type=script&lang=js"
export * from "./candidateInfoCard.vue?vue&type=script&lang=js"
import style0 from "./candidateInfoCard.vue?vue&type=style&index=0&id=6e2596b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2596b7",
  null
  
)

export default component.exports